<template>
  <div class="select_dialog_embed">
    <div class="supplier_list_embed_msg" :class="{'select_dialog_embed_box_wper100': showType === 'sAnnounceDetail', 'select_dialog_embed_box_w660': showType === 'duBidLog'}">
      <div class="select_dialog_embed_box" :class="{'select_dialog_embed_box_per1140': showType === 'duBidPublish' ||  showType === 'duBidDetail'}">
        <!--弹出框头部-->
        <div class="select_dialog_embed_box_top">
          <p>{{title}}</p>
        </div>

        <!--弹出框信息-->
        <div class="select_dialog_embed_box_content">
          <!--发布出价-->
          <div v-if="showType === 'duBidPublish'" class="select_dialog_embed_box_handle" :class="{'select_dialog_embed_box_content_per95': showType === 'duBidPublish'}">
            <div class="select_dialog_embed_box_handle_top">
              <div>
                <el-select v-model="selectStore" placeholder="请选择">
                  <el-option
                    v-for="item in storeList"
                    :key="item.Id"
                    :label="item.ShopName"
                    :value="item.Id">
                  </el-option>
                </el-select>
              </div>
              <div>
                <input type="text" v-model="numId" placeholder="链接ID" maxlength="30">
              </div>
              <button class="btn_normal w116 ml50" @click="downDewuLinkPriceByNumId()">下载查询</button>
              <div class="ml50 mr30">
                <!--<input type="text" v-model="uniformPrice" @blur="uniformPriceFormFun()" placeholder="价格（元）">-->
                <input type="text" v-model="uniformPrice" placeholder="价格（元）">
              </div>
              <button class="btn_normal w116" @click="uniformPriceFormBtn()">统一价格</button>
            </div>

            <div class="select_dialog_embed_box_handle_second">
              <button class="btn_normal" @click="getLowestPriceBySkuIds()">查询SKU最低价</button>
              <button class="btn_normal" @click="getStockBySkuIds()">计算可同步的库存</button>
              <button class="btn_normal fr" @click="cancelDewuPrice()">取消出价</button>
            </div>

            <!--表格-->
            <div style="max-height: 400px; overflow: auto;">
              <table class="table tb_border">
                <thead>
                <tr>
                  <th><input type="checkbox" title="全选" v-model="checkAll" @click="checkOneOrAll()"/></th>
                  <th>得物链接ID</th>
                  <th>得物SKUID</th>
                  <th>货号</th>
                  <th>尺码</th>
                  <th>最新出价(元)</th>
                  <th>平台最低价(元)</th>
                  <th>库存</th>
                  <th>颜色</th>
                  <th>零售价</th>
                </tr>
                </thead>
                <tbody v-if="list.length">
                <tr v-for="(item, index) in list" :key="index">
                  <!--<td rowspan="3"><input type="checkbox" title="选择" v-model="checkboxModel[index]"></td>-->
                  <td><input type="checkbox" title="选择" v-model="checkboxModel[index]"></td>
                  <td>{{item.NumId}}</td>
                  <td>{{item.NumSkuId}}</td>
                  <td>{{item.GoodsId}}</td>
                  <td>{{item.Size}}</td>
                  <td><input v-positive-int type="number" v-model="item.BiddingPrice" maxlength="9" style="width: 50px"></td>
                  <td>{{item.LowestPrice}}</td>
                  <td><input v-positive-int type="text" v-model="item.Stock" maxlength="9" style="width: 50px"></td>
                  <td>{{item.Color}}</td>
                  <td>{{item.linkSellPrice}}</td>
                </tr>
                </tbody>
                <tbody v-if="!list.length">
                <tr>
                  <td colspan="10">暂时没有相关信息</td>
                </tr>
                </tbody>
              </table>
            </div>

            <!--取消出价-->
            <div v-if="isCancelPrice" class="error_log disflex">
              <p class="cancel_price">是否取消所选数据的出价？</p>

              <button class="btn_normal" @click="cancelDewuPriceBySkuIds()">确认</button>
              <button class="btn_cancel" @click="isCancelPrice = false">关闭</button>
            </div>

            <!--发布出价报错日志-->
            <div v-if="isErrorLog" class="error_log">
              <div style="max-height: 400px; overflow: auto;">
                <table class="table tb_border">
                  <thead>
                  <tr>
                    <th>得物链接ID</th>
                    <th>错误原因</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item, index) in errorLogList" :key="index">
                    <td>{{item.NumId}}</td>
                    <td>{{item.ErrorContent}}</td>
                  </tr>
                  </tbody>
                  <!-- <tbody v-if="!list.length">
                  <tr>
                    <td colspan="4">暂时没有相关的数据</td>
                  </tr>
                  </tbody> -->
                </table>
              </div>

              <button class="btn_cancel" @click="closeErrorLog()">关闭</button>
            </div>
          </div>

          <!--链接出价详情-->
          <div v-if="showType === 'duBidDetail'" class="select_dialog_embed_box_handle" :class="{'select_dialog_embed_box_content_per95': showType === 'duBidDetail'}">
            <!--表格-->
            <table class="table tb_border">
              <thead>
              <tr>
                <th>得物链接ID</th>
                <th>得物SKUID</th>
                <th>货号</th>
                <th>颜色</th>
                <th>尺码</th>
                <th>零售价</th>
                <th>最新出价(元)</th>
              </tr>
              </thead>
              <tbody  v-if="list.length">
              <tr v-for="(item, index) in list" :key="index">
                <!--<td rowspan="3"><input type="checkbox" title="选择" v-model="checkboxModel[index]"></td>-->
                <td>{{item.NumId}}</td>
                <td>{{item.NumSkuId}}</td>
                <td>{{item.GoodsId}}</td>
                <td>{{item.Color}}</td>
                <td>{{item.Size}}</td>
                <td>{{item.LinkSellPrice}}</td>
                <td>{{item.BiddingPrice}}</td>
              </tr>
              </tbody>
              <tbody v-if="!list.length">
              <tr>
                <td colspan="10">暂时没有相关信息</td>
              </tr>
              </tbody>
            </table>
          </div>

          <!--取消所有出价-->
          <div v-if="showType === 'duBidCanceled'" class="select_dialog_embed_box_handle">
            <p class="title">确认取消当前链接的线上所有出价</p>
          </div>

          <!--批量取消所有出价-->
          <div v-if="showType === 'batchCancel' && !logList.length" class="select_dialog_embed_box_handle">
            <p class="title">确认取消当前选择链接的线上所有出价</p>
          </div>

          <!--批量取消出价错误页面-->
          <div v-if="showType === 'batchCancel' && logList.length" class="select_dialog_embed_box_handle">
            <table class="table tb_border">
              <thead>
              <tr>
                <th>链接ID</th>
                <th>错误内容</th>
              </tr>
              </thead>
              <tbody >
              <tr v-for="(item) in logList">
                <td>{{item.NumId}}</td>
                <td>{{item.ErrorContent}}</td>
                <!--<td>链接ID</td>-->
                <!--<td>错误内容</td>-->
              </tr>
              </tbody>
            </table>
          </div>

          <!--日志-->
          <div v-if="showType === 'duBidLog'" class="select_dialog_embed_box_handle">
            <table class="table tb_border">
              <thead>
              <tr>
                <th>链接ID</th>
                <th>内容</th>
                <th>操作人</th>
                <th>操作时间</th>
              </tr>
              </thead>
              <tbody v-if="logList.length">
              <tr v-for="(item, index) in logList" :key="index">
                <td>{{item.NumId}}</td>
                <td>{{item.Info}}</td>
                <td>{{item.CreaterName}}</td>
                <td>{{item.CreateTime | time}}</td>
              </tr>
              </tbody>
              <tbody v-if="!logList.length">
              <tr>
                <td colspan="4">暂时没有相关信息</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!--弹出框底部-->
        <div class="select_dialog_embed_box_bottom">
          <span v-if="showType === 'duBidPublish'" class="fcDel mr30">确认发布系统将自动取消原有SKUID的出价</span>
          <button v-if="showType === 'duBidPublish'" class="btn_normal" @click="confirmBidPrice()">确认发布出价</button>
          <button v-if="showType === 'duBidCanceled'" class="btn_normal" @click="cancelDewuPriceByNumId()">确定</button>
          <button v-if="showType === 'batchCancel' && !logList.length" class="btn_normal" @click="batchCancelDewuPriceByNumId()">确定</button>
          <button class="btn_cancel" @click="submitBtn()">关闭</button>
        </div>
      </div>

      <!--信息提示框-->
      <msg-dialog v-if="isMsg"
                  :is-suc="isSuc"
                  :txt="txtMsg" @closebtn="closeMsgDialog"></msg-dialog>
    </div>

    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="'NOP'"></loading-dialog>
  </div>
</template>

<script>
  import MsgDialog from '../../public-component/msg-dialog';
  import LoadingDialog from '../../public-component/loading-dialog';

    export default {
        name: "du-bid-management-embed-msg",
      /**
       *  title：  头部名
       *  showType: sAnnounceDetail=供应商公告信息
       *  msg: 互传的信息
       * */
      props: ['title', 'showType', 'msg'],
      components: {MsgDialog, LoadingDialog},
      watch: {
        'checkboxModel': function (val) {
          let flag = true;
          val.forEach((value) => {
            if (!value) {
              flag = false;
              return flag;
            }
          });
          this.checkAll = flag;
          if (!this.checkboxModel.length) {
            this.checkAll = false;
          }
        } // 单选
      },
      directives: {
        // 监听input是否是正整数
        positiveInt: {
          bind: function(el) {
            el.handler = function() {
              el.value = Number(el.value.replace(/\D+/, ''))
              // el.value = Number(el.value.replace(/^[0-9]*[1-9][0-9]*$/, ''))
            }
            el.addEventListener('input', el.handler)
          },
          unbind: function(el) {
            el.removeEventListener('input', el.handler)
          }
        }
      },
      data() {
        return {
          list: [
           /* {
              NumId: '',
              NumSkuId: '',
              GoodsId: '',
              Color: '',
              Size: '',
              LinkSellPrice: '',
              BiddingPrice: '',
              Stock: null
            }*/
          ], // 列表数据
          checkAll: false, // 全选
          checkboxModel: [], // checkbox框值
          storeList: [], // 店铺
          selectStore: '', // 选择的店铺
          numId: null, // 链接ID
          uniformPrice: null, // 统一价格
          uniformPriceFlag: false, // 判断价格闭包
          isCancelPrice: false, // 取消出价
          isErrorLog: false, // 是否显示日志代码
          errorLogList: [], // 报错日志
          showLowPrice: false, // 是否显示最低价
          showInventory: false, // 是否显示库存
          logList: [], // 日志
          isLoading: false, // 加载页面
          isMsg: false, // 信息框显示
          isSuc: false, // 是否成功
          txtMsg: '暂时没有相关的数据', // 信息框内容
          errorTxt: '', // 错误提示
          isShowMsgDialog: false, // 是否显示信息提示框
          time: 3, // 倒计时时间
          timer: null // 计时器
        }
      },
      methods: {
        // 单选/全选
        checkOneOrAll() {
          for (let i = 0; i < this.checkboxModel.length; i++) {
            this.checkboxModel[i] = !this.checkAll;
          }
        },

        // 获取店铺下拉框信息
        getDewuShopList() {
          this.$axios.post(this.Global.getDewuShopList).then((res) => {
            if (!res.data.errorMsg) {
              if (res.data.resData.length) {
                this.storeList = res.data.resData;
                this.selectStore = res.data.resData[0].Id;
                this.numId = this.msg;
                if (this.showType === 'duBidPublish' && this.msg.length) {
                  this.downDewuLinkPriceByNumId();
                }
              } else {
                this.storeList = res.data.resData;
                this.selectStore = '';
              }
            } else {
              this.storeList = [];
              this.selectStore = res.data.errorMsg;
            }
          });
        },

        // 统一价格格式
        uniformPriceFormFun() {
          if (!(/(^[0-9]*[1-9][0-9]*$)/.test(this.uniformPrice))) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '请输入正整数';
            this.uniformPriceFlag = false;
            return
          }
          this.uniformPriceFlag = true;
        },

        // 统一价格方法按钮
        uniformPriceFormBtn() {
          this.uniformPriceFormFun();
          if (this.uniformPriceFlag) {
            this.uniformPriceFun();
          }
        },

        // 统一价格
        uniformPriceFun() {
          for (let i = 0; i < this.list.length; i++) {
            console.log(this.list[i].BiddingPrice);
            this.list[i].BiddingPrice = this.uniformPrice;
            console.log(this.list[i].BiddingPrice);
          }
        },

        // 下载查询
        downDewuLinkPriceByNumId() {
          if (!this.numId) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '请输入链接ID';
            return;
          }
          this.checkAll = false;
          this.checkboxModel = [];
          this.isLoading = true;
          this.$axios.post(this.Global.downDewuLinkPriceByNumId(this.selectStore, this.numId)).then((res) => {
            this.isLoading = false;
            if (res.data.errorMsg.length) {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = res.data.errorMsg;
            } else {
              this.list = res.data.resData;
              for (let i = 0; i < res.data.resData.length; i++) {
                this.checkboxModel.push(false);
              }
              // this.uniformPriceFun();
              // this.isMsg = true;
              // this.isSuc = true;
              // this.txtMsg = '下载成功';
              // this.cancelBtn(true);
            }
          });
        },

        // 查询SKU最低价
        getLowestPriceBySkuIds() {
          if (!this.numId) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '请输入链接ID';
            return;
          }
          let checkboxModelLst = []; // 选择的skuId
          let listIndex = []; // 记住选择到的列表数据下标
          this.checkboxModel.findIndex((val, i) => {
            if (val === true) {
              listIndex.push(i);
              checkboxModelLst.push(this.list[i].NumSkuId);
            }
          });
          if (!checkboxModelLst.length) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '请选择要批量操作的链接ID';
            return;
          }
          this.$axios.post(this.Global.getLowestPriceBySkuIds(this.selectStore, this.numId), checkboxModelLst).then((res) => {
            console.log(res);
            if (res.data.errorMsg.length) {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = res.data.errorMsg;
            } else {
              // this.showLowPrice = true;
              // this.showInventory = false;
              if (res.data.resData) {
                for (let i = 0; i < listIndex.length; i++) {
                  for (let j = 0; j < res.data.resData.length; j++) {
                    if (this.list[listIndex[i]].NumSkuId == res.data.resData[j].NumSkuId) {
                      this.list[listIndex[i]].LowestPrice= res.data.resData[j].Lowwest;
                    }
                  }
                }
              }
            }
          });
        },

        // 计算可同步的库存
        getStockBySkuIds() {
          if (!this.numId) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '请输入链接ID';
            return;
          }
          let checkboxModelLst = []; // 选择的skuId
          let listIndex = []; // 记住选择到的列表数据下标
          this.checkboxModel.findIndex((val, i) => {
            if (val === true) {
              listIndex.push(i);
              checkboxModelLst.push(this.list[i].NumSkuId);
            }
          });
          if (!checkboxModelLst.length) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '请选择要批量操作的链接ID';
            return;
          }
          this.$axios.post(this.Global.getStockBySkuIds(this.selectStore, this.numId), checkboxModelLst).then((res) => {
            console.log(res);
            if (res.data.errorMsg.length) {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = res.data.errorMsg;
            } else {
              if (res.data.resData) {
                for (let i = 0; i < listIndex.length; i++) {
                  for (let j = 0; j < res.data.resData.length; j++) {
                    if (this.list[listIndex[i]].NumSkuId == res.data.resData[j].NumSkuId) {
                      this.list[listIndex[i]].Stock= res.data.resData[j].Stock;
                    }
                  }
                }
              }
            }
          });
        },

        // 取消出价
        cancelDewuPrice() {
          this.isCancelPrice = true;
        },

        // 批量对Sku取消出价
        cancelDewuPriceBySkuIds() {
          if (!this.numId) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '请输入链接ID';
            return;
          }
          let checkboxModelLst = []; // 选择的skuId
          this.checkboxModel.findIndex((val, i) => {
            if (val === true) {
              checkboxModelLst.push(this.list[i].NumSkuId);
            }
          });
          if (!checkboxModelLst.length) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '请选择要批量操作的货号';
            return;
          }
          this.$axios.post(this.Global.cancelDewuPriceBySkuIds(this.selectStore, this.numId), checkboxModelLst).then((res) => {
            console.log(res);
            if (res.data.errorMsg.length) {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = res.data.errorMsg;
            } else {
              this.isMsg = true;
              this.isSuc = true;
              this.txtMsg = '操作成功';
              // this.list = res.data.resData;
            }
          });
        },

        // 确认发布出价
        confirmBidPrice() {
          let flag = false;

          let checkboxModelLst = []; // 选择的skuId
          this.checkboxModel.findIndex((val, i) => {
            if (val === true) {
              if (!this.list[i].BiddingPrice || this.list[i].BiddingPrice <= 0) {
                flag = true;
                return;
              }
              checkboxModelLst.push({
                NumId: this.list[i].NumId,
                NumSkuId: this.list[i].NumSkuId,
                BiddingPrice: parseInt(this.list[i].BiddingPrice),
                Stock: this.list[i].Stock
              });
            }
          });
          if (flag) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '最新出价必须大于0';
            return;
          }
          if (!checkboxModelLst.length) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '请选择要批量操作的货号';
            return;
          }
          // console.log(checkboxModelLst);
          this.$axios.post(this.Global.confirmBidPrice(this.selectStore), checkboxModelLst).then((res) => {
            console.log(res);
            if (res.data.errorMsg.length) {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = res.data.errorMsg;
              this.errorLogList = res.data.resData;
              this.isErrorLog = true;
            } else {
              this.isMsg = true;
              this.isSuc = true;
              this.txtMsg = '发布成功';
            }
          })
        },

        // 关闭日志报错页面
        closeErrorLog() {
          this.isErrorLog = false;
        },

        // 通过链接Id 获取得物出价详情
        getDewuPriceDetailListByNumId() {
          this.$axios.post(this.Global.getDewuPriceDetailListByNumId(this.msg.shopId, this.msg.numId)).then((res) => {
            if (res.data.errorMsg.length) {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = res.data.errorMsg;
            } else {
              this.list = res.data.resData;
            }
          });
        },

        // 取消选择链接的所有出价
        cancelDewuPriceByNumId() {
          this.$axios.post(this.Global.cancelDewuPriceByNumId(this.msg.shopId, this.msg.numId)).then((res) => {
            if (res.data.errorMsg.length) {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = res.data.errorMsg;
            } else {
              this.isMsg = true;
              this.isSuc = true;
              this.txtMsg = '操作成功！';
              // this.cancelBtn(true);
            }
          })
        },

        // 获取得物链接出价的日志
        getDewuPriceLogList() {
          this.$axios.post(this.Global.getDewuPriceLogList(this.msg.shopId, this.msg.numId)).then((res) => {
            if (res.data.errorMsg.length) {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = res.data.errorMsg;
            } else {
              this.logList = res.data.resData;
            }
          })
        },

        // 批量取消选择链接的所有出价
        batchCancelDewuPriceByNumId() {
          this.isLoading = true;
          this.$axios.post(this.Global.batchCancelDewuPriceByNumId(this.msg.shopId), this.msg.numIdList).then(res => {
            this.isLoading = false;
            if (res.data.errorMsg.length) {
              this.logList = res.data.resData;
            } else {
              this.isMsg = true;
              this.isSuc = true;
              this.txtMsg = '操作成功！';
            }
          });
        },

        // 提交按钮
        submitBtn() {
          this.cancelBtn(this.showType, true);
          // 计时器
          if (this.isShowMsgDialog) {
            this.time = 3;
            const self = this;
            this.timer = setInterval(function () {
              self.time = --self.time;
              if (self.time < 1) {
                self.isShowMsgDialog = false;
                clearInterval(self.timer);
              }
            }, 1000);
          }
        },

        // 取消按钮
        cancelBtn(showType, issuc) {
          this.$emit('cancelbtn', {isShow: false, issuc: issuc, showType: showType});
        },

        // 接收提示框传送的数据
        closeMsgDialog(e) {
          this.isMsg = e;
          if (this.isSuc && this.showType !== 'duBidPublish') {
            this.cancelBtn(true);
          }
          if (this.isSuc && this.isCancelPrice) {
            this.isCancelPrice = false;
          }
        }
      },
      created() {
        if (this.showType == 'duBidPublish') {
          this.getDewuShopList();
        } else if (this.showType == 'duBidLog') {
          this.getDewuPriceLogList();
        } else if (this.showType == 'duBidDetail') {
          this.getDewuPriceDetailListByNumId();
        }
      }
    }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";

  .select_dialog_embed {
    .select_dialog_embed_box {
      &.select_dialog_embed_box_per1140 {
        width: 1140px;
      }

      .select_dialog_embed_box_content {
        position: relative;

        .error_log {
          position: absolute;
          top: -30px;
          left: 0;
          height: calc(100% + 90px);
          width: 100%;
          background-color: rgba(0, 0, 0, 0.7);
          /*max-height: 540px;*/
          /*overflow: auto;*/
          &.disflex {
            display: flex;
            justify-content: center;
            align-items: center;
          }

          p.cancel_price {
            text-align: center;
            background-color: #fff;
            /*margin: 55px 245px;*/
            width: 400px;
            height: 100px;
            line-height: 100px;
          }

          .table {
            margin: 30px 130px;
            width: calc(100% - 260px);
            background: #fff;
          }

          .btn_normal {
            position: absolute;
            bottom: 12px;
            right: 176px;
          }

          .btn_cancel {
            position: absolute;
            bottom: 13px;
            right: 30px;
          }
        }
      }

      .select_dialog_embed_box_handle {
        &.select_dialog_embed_box_content_per95 {
          width: 95%;
        }

        .select_dialog_embed_box_handle_top {
          & > div {
            display: inline-block;
            width: 187px;

            input[type='text'] {
              width: 100%;
            }
          }
        }
      }
    }
  }

  .supplier_list_embed_msg {
    max-height: 100%;

    &.select_dialog_embed_box_w660 {
      width: 660px;

      .select_dialog_embed_box {
        width: 100%;

        .select_dialog_embed_box_handle {
          width: 100%;
          margin: 0;
          max-height: 550px;
          overflow: auto;
        }
      }

      td {
        min-width: 100px;
      }
    }

    &.select_dialog_embed_box_wper100 {
      width: 90%;
      min-width: 580px;

      .select_dialog_embed_box {
        width: 100%;

        .select_dialog_embed_box_handle {
          width: 80%;
          /*height: 400px;*/
          /*height: 595px;*/
          min-height: 380px;
          max-height: 500px;
          padding: 0 10%;
          margin: 10px auto 0;
          overflow-y: auto;

          .title {
            font-size: 20px;
            font-weight: bold;
            text-align: center;
            padding: 15px 0;
          }

          .times {
            text-align: right;
            margin-right: 15%;
            padding-bottom: 10px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/goods-management/du-bid-management-embed-msg.vue